import { CavernsSubmodeKeyType } from 'dt-common/generated/types/enums';
import { ApiErrorMessage } from 'dt-common/types/ApiErrorMessages';
import { CavernsDispatcher, CurrencyDispatcher } from '~/flux/dispatchers';
import mutationCavernsReturnToSurface from '~/graphql/caverns/mutationCavernsReturnToSurface';
import { GraphQlRequestError } from '~/graphql/graphqlClient';
import { logError } from '~/logger';
import messages from '../messages';

export default async function returnToSurface(
  { playerId, emit, onMissingCavernsRunData }: { playerId: string; emit: (message: string, data: any) => void; onMissingCavernsRunData: () => void; },
  { game_submode }: { game_submode: CavernsSubmodeKeyType; }
) {
  try {
    const data = await mutationCavernsReturnToSurface({
      playerId,
      game_submode,
    });

    data.currency2 !== undefined &&
      CurrencyDispatcher.handleCurrencyAction({
        actionType: CurrencyDispatcher.NEW_CURRENCY_BALANCE,
        currency2: data.currency2,
      });

    emit(messages.RETURNED_TO_SURFACE, data);

    CavernsDispatcher.handleCavernsAction({
      actionType: CavernsDispatcher.RETURNED_TO_SURFACE,
      ...data,
    });
  } catch (err) {
    if (err instanceof GraphQlRequestError && err.errors.find((error) => error.message === ApiErrorMessage.NO_CURRENT_RUN_FOUND)) {
      onMissingCavernsRunData();
      return;
    }
    logError(err, {
      module: 'CavernsStore',
      func: 'returnToSurface',
      playerId,
      game_submode,
    });
  }
}
